/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WorkflowInputFeature = {
  name: string
  /**
   * * `TEXT` - Text
   * * `NUMBER` - Number
   * * `BOOLEAN` - Boolean
   * * `DATE` - Date
   * * `LIST` - List
   * * `UNDEFINED` - Undefined
   * * `DICT` - dict
   */
  type?: WorkflowInputFeature.type
  feature_nesting_separator?: string
  /**
   * Set to null as a default value to be computed on demand to avoid the huge migration
   */
  is_used?: boolean | null
  is_required?: boolean
  /**
   * * `workflow` - workflow
   * * `project_node` - project_node
   * * `workflow_and_project_node` - workflow_and_project_node
   */
  readonly source: WorkflowInputFeature.source
}
export namespace WorkflowInputFeature {
  /**
   * * `TEXT` - Text
   * * `NUMBER` - Number
   * * `BOOLEAN` - Boolean
   * * `DATE` - Date
   * * `LIST` - List
   * * `UNDEFINED` - Undefined
   * * `DICT` - dict
   */
  export enum type {
    TEXT = "TEXT",
    NUMBER = "NUMBER",
    BOOLEAN = "BOOLEAN",
    DATE = "DATE",
    LIST = "LIST",
    UNDEFINED = "UNDEFINED",
    // TODO: commented out as DICTS are unsupported
    // DICT = 'DICT',
  }
  /**
   * * `workflow` - workflow
   * * `project_node` - project_node
   * * `workflow_and_project_node` - workflow_and_project_node
   */
  export enum source {
    WORKFLOW = "workflow",
    PROJECT_NODE = "project_node",
    WORKFLOW_AND_PROJECT_NODE = "workflow_and_project_node",
  }
}
